import React from "react";
import { useCaseStudyId } from "../../../../context/CaseStudyContext";

const CaseStudySticky = ({ data }) => {
  const { caseStudyId } = useCaseStudyId();

  return (
    <>
      {data?.map((v, i) => (
        <img
          key={i}
          src={v.image_url}
          className={`opacity-0  sticky top-28 h-96 rounded-3xl  ${
            caseStudyId == v.id ? "opacity-100 block " : "opacity-0 hidden"
          } h-96  w-full object-center`}
        />
      ))}
    </>
  );
};

export default CaseStudySticky;
